import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uccdexy6ud: FaireBrandEntity = {
  token: "b_uccdexy6ud",
  type: "brand",
  name: "Body&Soul",
  avatarUrl:
    "https://cdn.faire.com/fastly/9d2b16e23a1b5c72950601fcbedf7b6e661bd600381d81e6183aa58648cfe039.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/8b679175d4a5c752a4683f9d8f3ec6df6f77374663d2e41de4fd31b53bc3132c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9d2b16e23a1b5c72950601fcbedf7b6e661bd600381d81e6183aa58648cfe039.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/8b679175d4a5c752a4683f9d8f3ec6df6f77374663d2e41de4fd31b53bc3132c.png",
  location: "brunswick, GA, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 2,
  isInsider: true,
  description:
    "Established 2016, Body&Soul is a handmade brand with 3 brick-and-mortar stores in Florida & Georgia specializing in making high quality healing goods that simply -work-! Being store owners ourselves we understand how important it is provide our wholesale buyers with fast, high-quality shipping and service. Our customers buy our products again and again once they experience the difference in their health, and we'd be happy to help spread the healing to your stores, too :)",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:33.553Z",
    importedBy: "entity-db-cli",
  },
};
